import currentUser from './currentUser'
import changeState from './changeStateReducer'
import {combineReducers} from 'redux'

const rootReducer = combineReducers({
    currentUser,
    changeState
})

export default rootReducer